<template>
  <div class="code">
        <div class="code_main">
            <span :class="{'active':one}">① 扫码</span>
            <span></span>
            <span :class="{'active':two}">② 填写物流单号</span>
            <span></span>
            <span :class="{'active':three}">③ 完成</span>
        </div>
      <div v-if="one">
        <div class="codelist">
            <div class="codeinput">
                <el-input v-model="codenum" placeholder="输入设备编码后按回车键，添加该设备"></el-input>
            </div>
            <div class="left">
                <el-table
                    :data="tableData"
                    :cell-style="{'text-align':'center'}"
                     :header-cell-style="{'text-align':'center','background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                    style="width: 100%">
                    <el-table-column label="订货单明细">
                        <el-table-column
                            prop="date"
                            label="设备ID"
                            width="180">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="设备名称"
                            width="180">
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            label="数量">
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </div>
            <div class="right">
                <el-table
                    :data="tableData"
                    :cell-style="{'text-align':'center'}"
                     :header-cell-style="{'text-align':'center','background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                    style="width: 100%">
                    <el-table-column label="已扫描设备">
                        <el-table-column
                            prop="date"
                            label="设备ID"
                            width="180">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="设备名称"
                            width="180">
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            label="设备编码">
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            label="操作">
                            <el-link :underline="false" @click="remove()">移除</el-link>
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </div>
            <div class="btn">
                <el-button  v-preventReClick @click="cancel()">取消出库</el-button>
                    <el-button  v-preventReClick type="primary" @click="nexts()">下一步</el-button>
            </div>
        </div>
      </div> 
      <div v-if="two" class="two">
             <div class="info">
                <p>基本信息</p>
                <div class="info_main">
                    <ul>
                        <li>订货单ID: <span>1000000000</span></li> 
                        <li>订货单名称: <span>4s店仅需</span></li> 
                        <li>状态: <span>已发货</span></li> 
                        <li>创建时间: <span>2020-08-24</span></li> 
                    </ul>
                </div>
            </div>
            <div class="info">
                <p>订货单明细</p>
                <div class="info_main" style="margin-top:15px">
                        <el-table
                            :cell-style="{'text-align':'center'}"
                     :header-cell-style="{'text-align':'center','background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                            :data="tableDatading"
                            style="width: 100%">
                            <el-table-column
                                prop="date"
                                label="设备ID"
                                width="180">
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="设备名称"
                                width="180">
                            </el-table-column>
                            <el-table-column
                                prop="address"
                                label="数量">
                            </el-table-column>
                        </el-table>
                </div>
            </div>
            <div class="info">
                <p>发货单明细</p>
                <div class="info_main" style="margin-top:15px">
                        <el-table
                            :cell-style="{'text-align':'center'}"
                             :header-cell-style="{'text-align':'center','background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                            :data="tableDatasend"
                            style="width: 100%;margin-top:15px">
                            <el-table-column
                                prop="date"
                                label="设备ID"
                                width="180">
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="设备名称"
                                width="180">
                            </el-table-column>
                            <el-table-column
                                prop="address"
                                label="数量">
                            </el-table-column>
                        </el-table>
                </div>
            </div>
            <div class="info">
                <p style="margin-bottom: 15px">请确认设备无误后填写物流单号</p>
                 <span class="span">物流单号:</span><el-input v-model="ordernumber" placeholder="物流单号" style="float: left;width: 30%;"></el-input>
                <div class="btn">
                            <el-button  v-preventReClick @click="back()">返回</el-button>
                            <el-button  v-preventReClick type="primary" @click="finesh()">完成</el-button>
                </div>
            </div>
      </div>
      <div v-if="three" class="three">
          <div class="success">
              <img src="../assets/success.png" alt="">
              <p>出库成功</p>
              <el-button  v-preventReClick type="primary" @click="backorder()">返回订货单列表</el-button>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            code: true,
            codenum:'',
            tableData:[],
            one:true,
            two:false,
            three:false,
            tableDatading:[],
            tableDatasend:[],
            ordernumber:''
        }
    },
    methods:{
        nexts(){
            this.one = false
            this.two = true
            this.three = false
        },
        cancel(){
           this.$confirm('取消出库后，已经扫描的设备，不会保存，确认取消吗?', '取消出库', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                this.$message({
                    type: 'success',
                    message: '出库成功!'
                });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消出库'
                });          
            }); 
        },
        back(){
            this.one = true
            this.two = false
            this.three = false
        },
        finesh(){
            this.one = false
            this.two = false
            this.three = true
        },
        backorder(){
            this.$router.push('/orderfrom')
        }
    }
}

</script>
<style lang="less" scoped>
.code{
    .code_main{
        background: #fff;
        padding: 15px 200px;
        box-sizing: border-box;
        border-right: 5px;
        text-align: center;
        overflow: hidden;
        border-radius: 5px;
        span{
            float: left;
            display: block;
        }
        span:nth-child(1),span:nth-child(5){
            width: 8%;
        }
        span:nth-child(3){
            width: 17%;
            text-align: center;
        }
        span:nth-child(2),span:nth-child(4){
            width: 30%;
            height: 1px;
            background: #000;
            margin-top: 12px;
        }
        .active{
            color: #409eff;
        }
    }
    .codelist{
        margin-top: 15px;
        background: #fff;
        padding: 15px;
        box-sizing: border-box;
        border-right: 5px;
        overflow: hidden;
        .codeinput{
            padding: 15px;
            box-sizing: border-box;
            /deep/.el-input__inner{
                height: 100px!important;
                font-size: 50px;
            }
        }
        .left{
            width: 40%;
            float: left;
            margin-top: 15px;
        }
        .right{
            width: 58%;
            float: right;
            margin-top: 15px;
        }
        .btn{
            float: left;
            width: 100%;
            text-align: center;
            margin-top: 50px;
        }
    }
    .two{
        margin-top: 15px;
        background: #fff;
        padding: 15px;
        box-sizing: border-box;
        border-right: 5px;
        overflow: hidden;
        .info{
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 15px;
        box-sizing: border-box;
        .span{
            float: left;
            display: block;
            width: 7%;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
        }
        p{
            font-size: 18px;
            font-weight: 700;
            height: 40px;
            line-height: 40px;
        }
        .info_main{
            ul{
                overflow: hidden;
                width: 100%;
                li{
                    width: 33.3%;
                    float: left;
                    height: 35px;
                    line-height: 35px;
                    font-size: 14px;
                }
            }
        }
        .btn{
            text-align: center;
            margin-top: 107px;
            button{
                width: 10%;
                margin-right: 2%;
            }
        }
    }
    .info:last-child{
        border-bottom: none;
    }
    }
    .three{
        background: #fff;
        border-radius: 5px;
        text-align: center;
        margin-top: 15px;
        height: 500px;
        overflow: hidden;
        .success{
            margin-top: 180px;
            p{
                font-size: 20px;
                margin-top: 15px;
                font-weight: 700;
            }
            button{
                margin-top: 110px;
            }
        }
    }
}
</style>